import React, { Component } from 'react';
import './index.less';
import Style from './index.less';

// PPT直播（live）的用户引导框，没有什么功能就是用户教育。

export default class LiveFlipPageTip extends Component {

    static index = 0;
    constructor(props) {
        super(props);
        this.state = {
            isShown: false,
            hideAnimating: false,
            config: {},  //drop内容位置，大小，是否可滚动等等
        }

        this.id = 'custom-flip-tip-id-' + LiveFlipPageTip.index++;
        this.firstRender = true;  //第一次不渲染内容
        this.hiding = false;
        this.timer = null;
    }
    componentWillUnmount() {
        this.unmount = true;
        document.body.removeEventListener("click", this.bodyClickHandler);
        // window.removeEventListener('resize', this.resize);
        if (this.timer !== null) {
            clearTimeout(this.timer);
        }

    }

    bodyClickHandler = (e) => {
        //延迟一下，让body里的元素先执行click
        this.hiding = true;
        setTimeout(() => {
            if (this.state.isShown && this.hiding) {
                this.hiding = false;
                let clickOnMenu = this.clickOnMenu(e, this.props.maxLevel || 20);
                if (!clickOnMenu) {
                    this.hide();
                }
            }
        }, 50)
    }

    //点击的位置是否在菜单组件上
    clickOnMenu = (e, maxLevel) => {
        let curDom = e.target;
        let level = 0;
        while (curDom && level < maxLevel) {
            curDom = curDom.parentNode;
            level++;
            if (curDom && curDom.id && curDom.id === this.id) {
                return true;
            }
        }
        return false;
    }
    autoHide = () => {
        if (this.timer !== null) {
            clearTimeout(this.timer);
        }
        let that = this;
        this.timer = setTimeout(() => {
            that.hide();
        }, 2500);

    }
    show = () => {
        if (this.props.disabled) {
            return;
        }
        if (!this.state.isShown) {
            document.body.addEventListener("click", this.bodyClickHandler)
            this.setState({
                isShown: true,
            }, () => {
                    this.onVisibleChange(true);
                    this.autoHide();
            });
        } else {

        }
    }
    hide = () => {
        if (this.props.disabled) {
            return;
        }
        if (this.state.isShown) {
            this.setState({
                isShown: false,
            }, () => {
                this.onVisibleChange(false);
            });
            document.body.removeEventListener("click", this.bodyClickHandler);
        }
    }

    isShown = () => {
        return this.state.isShown;
    }

    onVisibleChange = (visible) => {
        if (this.props.onVisibleChange) {
            this.props.onVisibleChange(visible);
        }
    }
    render() {


        return (
            <div id={this.id} className={'dialog-wrapper-flipPage ' + Style['dialog-wrapper-flipPage'] + ' bubble-flipPage ' + Style['bubble-flipPage'] + ' top-flipPage ' + Style['top-flipPage'] + ' ' + this.props.className}
                hidden =  {!(this.state.isShown)}
            >
                <div className={'modal-content-flipPage ' + Style['modal-content-flipPage']}>
                    <div className={Style.text}>
                        <div className={Style.h1}>你可以翻页查看已播放的幻灯片，
快去试试吧。</div>
                    </div>
                </div>
            </div>
        );
    }
}